import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CdTimerComponent } from 'angular-cd-timer';
import { ToasterService } from 'angular2-toaster';
import { DxTextBoxComponent, DxValidatorComponent } from 'devextreme-angular';
//import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})
export class VerifyOtpComponent implements OnInit {
  phoneNum: any;
  selectedCountryCode: any;
  otpNewValue: any = null;
  url: any;
  userData = [];

  constructor(private config: ConfigService,
    private toasterService: ToasterService, public router: Router, private loginService:LoginService) { }

  @ViewChild("basicTimer", { static: true }) basicTimer: CdTimerComponent;
  @ViewChild("otpText1", { static: false }) public otpBox1: DxTextBoxComponent;
  @ViewChild("otpText2", { static: false }) public otpBox2: DxTextBoxComponent;
  @ViewChild("otpText3", { static: false }) public otpBox3: DxTextBoxComponent;
  @ViewChild("otpText4", { static: false }) public otpBox4: DxTextBoxComponent;
  @ViewChild("otpText5", { static: false }) public otpBox5: DxTextBoxComponent;
  @ViewChild("otpText6", { static: false }) public otpBox6: DxTextBoxComponent;
  valueofOTP: boolean = true;
  otpValue1: string = null;
  otpValue2: string = null;
  otpValue3: string = null;
  otpValue4: string = null;
  otpValue5: string = null;
  otpValue6: string = null;

  ngOnInit() {
    this.config.getLocalStorageData();
    this.userData = JSON.parse(this.config.userData);
    this.phoneNum = this.config.countryTelCode + '-' + this.userData['mobNumber']
    this.basicTimer.start();
    setTimeout(() => {
      this.valueofOTP = false;
    }, 120000);
  }

  focusOutFunction(e) {
    if (this.otpValue1 != "") {
      this.otpBox2.instance.focus();
    }
  }
  focusOutFunction1(e) {
    if (this.otpValue2 != "") {
      this.otpBox3.instance.focus();
    }
    if (this.otpValue2 == "") {
      this.otpBox1.instance.focus();
    }
  }
  focusOutFunction2(e) {

    if (this.otpValue3 != "") {
      this.otpBox4.instance.focus();
    }
    if (this.otpValue3 == "") {
      this.otpBox2.instance.focus();
    }
  }
  focusOutFunction3(e) {

    if (this.otpValue4 != "") {
      this.otpBox5.instance.focus();
    }
    if (this.otpValue4 == "") {
      this.otpBox3.instance.focus();
    }
  }
  focusOutFunction4(e) {

    if (this.otpValue5 != "") {
      this.otpBox6.instance.focus();
    }
    if (this.otpValue5 == "") {
      this.otpBox4.instance.focus();
    }
  }
  focusOutFunction5(e) {
    if (this.otpValue6 == "") {
      this.otpBox5.instance.focus();
    }
  }

  onlyNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  resendOTP() {
   
    this.valueofOTP = true;
    this.clearOTP();

    this.loginService.sendOTPForSignUp(this.userData['mobNumber'], this.userData['countryCode'],this.constructor.name).subscribe(result => {
      console.log(result);

      if(result['message'].code == 0){
        this.toasterService.pop("success", "OTP Sent Successfully!");
        this.basicTimer.start();
        setTimeout(() => {
          this.valueofOTP = false;
        }, 120000);
      }else if(result['message'].code == 1){
        this.toasterService.pop("error","Invalid Mobile Number!")
      }else if(result['message'].code == 1005){
        this.toasterService.pop("error","Authtoken not valid!")
      }else if(result['message'].code == 4006){
        this.toasterService.pop("error","Requested data not found!")
      }else{
        this.toasterService.pop(result['message'].message);
      }
     })
    
  }

  verifyOTPandLogin(e) {

    if(this.otpValue1 != null || this.otpValue2 != null || this.otpValue3 != null || this.otpValue4 != null || this.otpValue5 != null || this.otpValue6 != null){
      this.otpNewValue = parseInt(this.otpValue1.concat(
        this.otpValue2,
        this.otpValue3,
        this.otpValue4,
        this.otpValue5,
        this.otpValue6
      ));
      
      if (this.otpNewValue.toString().length == 6) {
        this.loginService.verifyOTPforSignUp(this.otpNewValue, this.userData)
        .subscribe(result => {
          console.log(result);
      
          if(result["message"].code == 1018){
            //return;
            this.loginService.signUP(this.config.encryptedPassword,this.userData)
            .subscribe(result => {
              console.log(result);
              if(result["code"] == 0){
                this.toasterService.pop("success", "New User Created Successfully!");
                localStorage.clear();
                window.location.href = result["data"].data.url;
              }else if(result["code"] == 2409){
                this.toasterService.pop('error', result["message"]);
                this.router.navigate(['fynd-login'])
              }else if(result["code"] == 2407){
                this.toasterService.pop('error', result["message"]);
                this.router.navigate(['fynd-login'])
              }else if(result["code"] == 888){
                this.toasterService.pop('error', "Account created successfully. Please login after some time!!");
                this.router.navigate(['fynd-login'])
              }else{
                this.toasterService.pop('error', result["message"]);
                this.router.navigate(['fynd-login'])
              }
              // if(result["response"] == "FAIL"){
              //   if(result["2409"]){
              //     this.toasterService.pop("error", result["2409"]); //User already registered
              //   }else if(result["2407"]){
              //     this.toasterService.pop("error", result["2407"]); //We are facing some issue in creating user Please contact with adminstrator Error-2406
              //   }else{
              //     this.toasterService.pop("error", "Something went wrong. Please try again!"); 
              //   }
                
              //   this.router.navigate(['fynd-login'])
              // }else if(result["status"] == "failed"){
              //   this.toasterService.pop("error", result["message"]); //phone_number is invalid 
              //   this.router.navigate(['fynd-login'])
              // }else{
              //   this.toasterService.pop("success", "New User Created Successfully!");
              //   localStorage.clear();
              //   window.location.href = result["data"].url;
              // }
            })
          }else if(result["message"].code == 1017){ //OTP not Match
            this.toasterService.pop('error', 'Invalid', result["message"].message)
          }else if(result["message"].code == 5007){ 
            this.toasterService.pop('error', 'Invalid', result["message"].message)
          }else{ 
            this.toasterService.pop('error', result["message"].message);
          }
          });

      } else {
        this.toasterService.pop("error", "Invalid OTP");
        this.clearOTP();
      }
    }else{
      this.toasterService.pop("error", "Invalid OTP");
    }

    
   
  }


  clearOTP(){
    this.otpValue1 = null;
    this.otpValue2 = null;
    this.otpValue3 = null;
    this.otpValue4 = null;
    this.otpValue5 = null;
    this.otpValue6 = null;
  }

}
